import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatIconRegistry } from '@angular/material/icon';
import { AdminShellModule } from '@ui-components/admin/shell';
import { AdminNavModule } from '@ui-components/admin/nav';
import { ORG_OPTION_LOOKUP } from '@ui-components/admin/org-picker';
import { SessionAuthInterceptor } from '@ui-components/services';
import { CookieService } from 'ngx-cookie-service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminAuthInterceptor } from './admin-auth.interceptor';
import { AdminOrganisationsService } from './services/admin-organisations.service';
import { PeopleMoveModule } from './people/people-move.module';

export function registerIconFontFactory(iconRegistry: MatIconRegistry): () => void {
  return () => iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    BrowserModule,
    HttpClientModule,
    AdminShellModule,
    AdminNavModule,
    PeopleMoveModule
  ],
  providers: [
    provideAnimationsAsync(),
    CookieService,
    { provide: HTTP_INTERCEPTORS, useClass: AdminAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SessionAuthInterceptor, multi: true },
    { provide: ORG_OPTION_LOOKUP, useExisting: AdminOrganisationsService },
    {
      provide: APP_INITIALIZER,
      useFactory: registerIconFontFactory,
      deps: [MatIconRegistry],
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
